import React from "react";
import ProperDate from "./ProperDate";
import WeatherIcon from "./WeatherIcon";
import TemperatureUnit from "./TemperatureUnit.js"

export default function WeatherDisplay(props) {
  return (
    <div className="WeatherDisplay">
      {" "}
      <h1>{props.data.city}</h1>
      <ul className="date">
        <li className="dateTime">
          <ProperDate date={props.data.date} />
        </li>
        <li className="description">{props.data.description}</li>
        <li>
            <TemperatureUnit celsius={props.data.temperature} />
         
        </li>
      </ul>
      <div className="main">
        <WeatherIcon code={props.data.icon} size={150}/>
      </div>
      <div className="parameters">
        <ul className="weather-parameters">
          <li className="param" id="humidity">
            Humidity: {props.data.humidity}%
          </li>
          <li className="param" id="wind"></li>
          <li className="param" id="clouds">
            Wind: {props.data.wind} km/h
          </li>
        </ul>
      </div>
    </div>
  );
}
